import { type ComponentPropsWithRef, type ReactNode } from 'react';
import { Flex } from '@repo/ui/Flex';
import { useInput } from './InputRoot.js';
import { clsx } from 'clsx';

import s from './Input.module.css';
import { cva } from 'class-variance-authority';

export const inputMessageVariants = cva(s.message, {
  variants: {
    variant: {
      default: s.defaultVariant,
      error: s.errorVariant,
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type InputMessageProps = ComponentPropsWithRef<'div'> & {
  className?: string;
  children?: ReactNode;
};

export const InputMessage = ({
  children,
  className,
  id,
  ...attrs
}: InputMessageProps) => {
  const { variant } = useInput();

  return (
    <Flex
      id={id}
      alignItems="center"
      className={clsx(inputMessageVariants({ variant }), className)}
      gap="g-8"
      padding="px-2"
      role={variant === 'error' ? 'alert' : undefined}
      aria-live={variant === 'error' ? 'polite' : undefined}
      {...attrs}
    >
      {children}
    </Flex>
  );
};
